import {
  isListingPhotoFeedbackSlug,
  LISTING_PHOTO_FEEDBACK_SLUGS,
} from "@/lib/listingPhotoFeedback";
import type { PresetEvidenceRule } from "@/lib/listing-review-rounds/types";

const PHOTO_SLUG_TO_SLOT: Record<string, 1 | 2 | 3> = {
  image_quality_main: 1,
  image_quality_photo_2: 2,
  image_quality_photo_3: 3,
};

const TEXT_PRESET_SLUGS: Record<string, "title" | "description" | "defects"> = {
  non_descriptive_title: "title",
  description_unacceptable: "description",
  missing_information: "description",
};

/**
 * Preset slug → what must change before resubmit (Phase 3 server enforcement).
 * `image_quality` (all photos) requires every present slot to change.
 */
export function getPresetEvidenceRules(
  reasonCodes: string[],
): PresetEvidenceRule[] {
  const rules: PresetEvidenceRule[] = [];
  for (const slug of reasonCodes) {
    if (slug === "image_quality") {
      rules.push({ slug, kind: "photo_slot", photoSlot: 1 });
      rules.push({ slug: "image_quality", kind: "photo_slot", photoSlot: 2 });
      rules.push({ slug: "image_quality", kind: "photo_slot", photoSlot: 3 });
      continue;
    }
    if (isListingPhotoFeedbackSlug(slug) && slug in PHOTO_SLUG_TO_SLOT) {
      rules.push({
        slug,
        kind: "photo_slot",
        photoSlot: PHOTO_SLUG_TO_SLOT[slug],
      });
      continue;
    }
    const textField = TEXT_PRESET_SLUGS[slug];
    if (textField) {
      rules.push({ slug, kind: textField });
      continue;
    }
    if (slug === "pricing_issues") {
      rules.push({ slug, kind: "price" });
    }
  }
  return rules;
}

/** Photo slots flagged by reason codes (for round row denormalization). */
export function flaggedPhotoSlotsFromReasonCodes(
  reasonCodes: string[],
): number[] | null {
  const slots = new Set<number>();
  for (const slug of reasonCodes) {
    if (slug === "image_quality") {
      slots.add(1);
      slots.add(2);
      slots.add(3);
      continue;
    }
    if (isListingPhotoFeedbackSlug(slug) && slug in PHOTO_SLUG_TO_SLOT) {
      slots.add(PHOTO_SLUG_TO_SLOT[slug]);
    }
  }
  if (slots.size === 0) return null;
  return [...slots].sort((a, b) => a - b);
}

export const LISTING_PHOTO_FEEDBACK_SLUG_LIST = LISTING_PHOTO_FEEDBACK_SLUGS;
